import React, {useState} from "react";
import {setLeadStatus} from "../api/leads";

export const LEAD_KIND = {ENQUIRY: "Enquiry", BROCHURE: "Brochure download", TOUR: "Tour booked"};
const STATUSES = [["NEW", "New"], ["CONTACTED", "Contacted"], ["CLOSED", "Closed"]];

const csvCell = (v) => `"${String(v ?? "").replace(/"/g, '""')}"`;

const downloadCsv = (leads) => {
    const rows = [["Date", "Type", "Property", "Name", "Mobile", "Email", "Message", "Status"],
        ...leads.map((l) => [l.createdAt ? new Date(l.createdAt).toLocaleString() : "", LEAD_KIND[l.kind], l.propertyTitle,
            l.name, l.mobile, l.email, l.message, l.status])];
    const blob = new Blob([rows.map((r) => r.map(csvCell).join(",")).join("\n")], {type: "text/csv"});
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = `ogm-leads-${new Date().toISOString().slice(0, 10)}.csv`;
    a.click();
    URL.revokeObjectURL(a.href);
};

const LeadsTab = ({leads, onChanged}) => {
    const [kind, setKind] = useState("ALL");
    const [error, setError] = useState("");
    const [saving, setSaving] = useState(null);
    const shown = leads.filter((l) => kind === "ALL" || l.kind === kind);

    const change = async (lead, status) => {
        setSaving(lead.id);
        setError("");
        try {
            await setLeadStatus(lead.id, status);
            await onChanged();
        } catch (err) {
            setError(err.message);
        } finally {
            setSaving(null);
        }
    };

    return (
        <div className="brk-card">
            <div className="brk-card__head">
                <div className="brk-filters" role="group" aria-label="Filter leads">
                    {["ALL", "ENQUIRY", "BROCHURE", "TOUR"].map((k) => (
                        <button key={k} type="button" aria-pressed={kind === k}
                                className={`brk-filter${kind === k ? " brk-filter--on" : ""}`} onClick={() => setKind(k)}>
                            {k === "ALL" ? "All" : LEAD_KIND[k]} <span>{leads.filter((l) => k === "ALL" || l.kind === k).length}</span>
                        </button>
                    ))}
                </div>
                {leads.length > 0 && (
                    <button type="button" className="brk-btn brk-btn--ghost brk-btn--sm" onClick={() => downloadCsv(shown)}>
                        Download CSV
                    </button>
                )}
            </div>
            {error && <div className="brk-notice brk-notice--error" role="alert">{error}</div>}
            {shown.length === 0 ? (
                <p className="brk-empty">No leads yet. They arrive when buyers enquire, download a brochure or book a tour on a live listing.</p>
            ) : (
                <div className="brk-table-wrap">
                    <table className="brk-table">
                        <thead>
                        <tr><th>When</th><th>Type</th><th>Property</th><th>Buyer</th><th>Message</th><th>Status</th></tr>
                        </thead>
                        <tbody>
                        {shown.map((l) => (
                            <tr key={l.id}>
                                <td>{l.createdAt ? new Date(l.createdAt).toLocaleDateString() : "—"}
                                    {l.scheduledAt && <div className="brk-hint">Tour: {new Date(l.scheduledAt).toLocaleString()}</div>}</td>
                                <td><span className={`brk-badge brk-badge--${l.kind === "ENQUIRY" ? "orange" : "grey"}`}>{LEAD_KIND[l.kind]}</span></td>
                                <td>{l.propertyTitle}</td>
                                <td>
                                    <div className="brk-strong">{l.name || "—"}</div>
                                    {l.mobile && (
                                        <div className="brk-contact">
                                            <a href={`tel:+91${l.mobile}`}>{l.mobile}</a>
                                            <a href={`https://wa.me/91${l.mobile}`} target="_blank" rel="noreferrer">WhatsApp</a>
                                        </div>
                                    )}
                                    {l.email && <a className="brk-hint" href={`mailto:${l.email}`}>{l.email}</a>}
                                </td>
                                <td className="brk-table__message">{l.message || "—"}</td>
                                <td>
                                    {l.kind === "TOUR" ? <span className="brk-badge brk-badge--grey">{l.status}</span> : (
                                        <select className="brk-input brk-input--sm" value={l.status} disabled={saving === l.id}
                                                aria-label={`Status of lead from ${l.name}`} onChange={(e) => change(l, e.target.value)}>
                                            {STATUSES.map(([v, label]) => <option key={v} value={v}>{label}</option>)}
                                        </select>
                                    )}
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};

export default LeadsTab;
